import { createFileRoute } from "@tanstack/react-router";
import { RequestDetail } from "../../components/transport/request-detail";

/** One trip (her `#/tpreq/<id>`): the dispatch desk's page; the guard is the Requests route's (`canDispatch`). */
export const Route = createFileRoute("/_app/logistics/transportation/requests/$requestId")({
	component: TripPage,
});

function TripPage() {
	const { requestId } = Route.useParams();
	return <RequestDetail key={requestId} requestId={requestId} />;
}
